import React from 'react'

const ExpandClose = (props) => (
  <svg width="9" height="10" viewBox="0 0 9 10" fill="none" {...props}>
    <path d="M0.924316 9.07568L6.92432 5.07568L0.924316 1.07568" stroke="currentColor" strokeWidth="2" />
  </svg>
)

export default ExpandClose
